import { useEffect, useRef } from "react";
import { useUserContext } from "api/user/UserProvider";

export const useApiFieldErrors = (setError, setReadOnly) => {
  const { apiErrorResponse, setApiErrorResponse } = useUserContext();
  const isInitialMount = useRef(true);

  useEffect(() => {
    setApiErrorResponse(null);
  }, []);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    if (apiErrorResponse && Object.keys(apiErrorResponse).length > 0) {
      Object.entries(apiErrorResponse).forEach(([field, errorInfo]) => {
        const message =
          typeof errorInfo === "string"
            ? errorInfo
            : errorInfo?.translationKey || errorInfo?.message || "unknown_error";
        setError(field, { type: "manual", message });
      });
      setReadOnly?.(false);
    }
  }, [apiErrorResponse, setError]);
};
